// CANONICAL COPY (GH #7115). src/constants/obligations/obl-risk-assessment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-risk-assessment',
  title: 'Perform information security risk assessment',
  description:
    'Execute the information security risk assessment process. Identify, analyse, and evaluate risks. Update the risk register.',
  category: 'risk',
  scfIds: ['SCF-RSK-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'risk-register-exists', description: 'Risk register contains identified risks' },
    {
      type: 'risks-reviewed',
      description: 'All risks have been reviewed (not in initial open state)',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'risks', label: 'Review Risk Register' }],
};
